import { Button, Card, ContentState } from '@omnipresentgroup/design-system';
import { useNavigate } from 'react-router';

import { INTEGRATIONS_PATH } from '../../constants';

export const XeroErrorPage = () => {
  const navigate = useNavigate();

  return (
    <Card>
      <ContentState
        id="xero-error-page"
        variant="error"
        title="Xero Integration Error"
        description="We encountered an issue during the Xero integration process. This error could be related to an incomplete configuration, a mismatch in the organisation selection, or a problem with the connection status. Please review the integration settings and ensure that all required permissions and configurations are correctly applied. If the problem persists, contact support for further assistance."
        callToAction={
          <Button onClick={() => navigate(INTEGRATIONS_PATH)}>
            Go back to integrations
          </Button>
        }
      />
    </Card>
  );
};
